import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
import GridRow from "backpack-ui/dist/components/gridRow";
var ArticleHeader = function (_a) {
    var children = _a.children;
    return (React.createElement(GridRow, { className: cn("ArticleHeader", styles.articleHeader) }, children));
};
export default ArticleHeader;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeader/index.tsx
// module id = zERC
// module chunks = 3